import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Joyride, { CallBackProps } from 'react-joyride';
import { themeColors } from 'utils/tailwind/tailwindHelpers';

import Celebration from '@/shared/components/atoms/Demo/Tour/Celebration';
import { useDemoSteps } from '@/shared/components/atoms/Demo/Tour/logic';
import TourTooltip from '@/shared/components/atoms/Demo/Tour/Tooltip';
import routes from '@/shared/constant/routes';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

const Tour = () => {
  const { freeTrialOver } = useFreeTrial();
  const [store] = useStore((store) => store);
  const isDemoFarm = store?.isDemoFarm;
  // const isLoadingPage = store?.isLoadingPage;

  const { user } = useAuth();

  const { push, pathname, isReady } = useRouter();

  const { openModal } = useModal();

  const [tour, setTour] = useState<ITourState>({
    step: 1,
    tourActive: false,
  });

  const { steps } = useDemoSteps();

  const handleTourEnd = () => {
    setTour((state) => {
      const updatedState = { ...state, tourActive: false };
      sessionStorage.setItem('tour', JSON.stringify(updatedState));
      if (state.step === steps.length - 1) openModal(<Celebration />);
      return updatedState;
    });
  };

  const handleCallback = (data: CallBackProps) => {
    const { index, type, action } = data;

    if (action === 'close') handleTourEnd();
    else if (type === 'step:after') {
      sessionStorage.setItem(
        'tour',
        JSON.stringify({ step: index + 1, tourActive: index < 4 })
      );
      if (index === 0 || index === 3)
        setTour({ step: index + 1, tourActive: true });
      else if (index === 1) {
        push(routes.statistics);
      } else if (index === 2) {
        push(routes.settlements);
      } else if (index === 4) {
        handleTourEnd();
      }
    }
  };

  useEffect(() => {
    const sessionData = sessionStorage.getItem('tour');
    if (sessionData) {
      const tour: ITourState = JSON.parse(sessionData);
      if (tour.tourActive) setTour({ step: tour.step, tourActive: true });
    } else {
      setTour({ step: 0, tourActive: true });
    }
  }, [pathname, isDemoFarm]);

  return (
    <Joyride
      run={
        tour.tourActive &&
        isReady &&
        // !isLoadingPage &&
        !!isDemoFarm &&
        user?.companyUser === 1 &&
        !freeTrialOver
      }
      continuous
      steps={steps}
      stepIndex={tour.step}
      callback={handleCallback}
      disableScrolling
      disableOverlayClose
      disableCloseOnEsc
      spotlightPadding={0}
      tooltipComponent={TourTooltip}
      styles={{
        options: {
          arrowColor: themeColors().primary['new-10'],
        },
      }}
    />
  );
};

export default Tour;
